<template>
  <div class="flex flex-col gap-16 justify-center items-center h-full">
    <div class="flex flex-col gap-16 w-full">
      <div v-for="i in count" :key="i">
        <!-- Desktop/tablet skeleton -->
        <div class="hidden md:flex items-start rounded-md border p-24 bg-white">
          <!-- Radio button -->
          <div
            v-if="hasRadioButton"
            class="w-20 h-20 pr-24 rounded-full border-2 border-grey-300 bg-grey-100 animate-pulse self-center"
          ></div>

          <!-- Main content -->
          <div class="flex-1">
            <div
              class="h-24 w-1/2 bg-grey-200 animate-pulse rounded mb-8"
            ></div>

            <div
              v-if="i === 1"
              class="h-20 w-80 bg-purple-200 animate-pulse rounded mb-12"
            ></div>

            <div
              v-else
              class="h-20 w-50 bg-blue-200 animate-pulse rounded mb-12"
            ></div>
            <div class="flex flex-col gap-8">
              <div class="flex items-center">
                <div
                  class="w-20 h-20 bg-blue-500 animate-pulse rounded mr-8"
                ></div>
                <div class="h-20 w-2/5 bg-grey-200 animate-pulse rounded"></div>
              </div>
              <div class="flex items-center">
                <div
                  class="w-20 h-20 bg-blue-500 animate-pulse rounded mr-8"
                ></div>
                <div class="h-20 w-3/5 bg-grey-200 animate-pulse rounded"></div>
              </div>
              <div class="flex items-center">
                <div
                  class="w-20 h-20 bg-blue-500 animate-pulse rounded mr-8"
                ></div>
                <div class="h-20 w-1/4 bg-grey-200 animate-pulse rounded"></div>
              </div>
            </div>
          </div>

          <!-- Distance -->
          <div class="h-24 w-48 bg-grey-200 animate-pulse rounded ml-16"></div>
        </div>

        <!-- Mobile skeleton -->
        <div class="md:hidden flex items-start rounded-md border p-24 bg-white">
          <!-- Radio button -->
          <div
            v-if="hasRadioButton"
            class="w-20 h-20 pr-24 rounded-full border-2 border-grey-300 bg-grey-100 animate-pulse"
          ></div>

          <!-- Main content -->
          <div class="flex-1">
            <div class="h-24 w-72 bg-grey-200 animate-pulse rounded mb-8"></div>
            <div
              v-if="i === 1"
              class="h-20 w-70 bg-purple-200 animate-pulse rounded mb-12"
            ></div>
            <div
              v-else
              class="h-20 w-70 bg-blue-200 animate-pulse rounded mb-12"
            ></div>

            <div class="flex items-center mb-8">
              <div
                class="w-20 h-20 bg-blue-200 animate-pulse rounded mr-8"
              ></div>
              <div class="h-20 w-3/5 bg-grey-200 animate-pulse rounded"></div>
            </div>
            <div class="flex items-center mb-8">
              <div
                class="w-20 h-20 bg-blue-200 animate-pulse rounded mr-8"
              ></div>
              <div class="h-20 w-full bg-grey-200 animate-pulse rounded"></div>
            </div>
            <div class="flex items-center mb-12">
              <div
                class="w-20 h-20 bg-blue-200 animate-pulse rounded mr-8"
              ></div>
              <div class="h-20 w-100 bg-grey-200 animate-pulse rounded"></div>
            </div>

            <!-- Mobile distance -->
            <div class="h-20 w-3/5 bg-grey-200 animate-pulse rounded"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoctorSkeletonLoader',
  props: {
    count: {
      type: Number,
      default: 3,
    },
    hasRadioButton: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
